/**
 * O backend pode prefixar texto enviado com *Nome do atendente:* (não anônimo).
 * O otimista no frontend guarda só o texto digitado — a igualdade estrita falha e a mensagem fica em "sending" (1 ✓).
 */
export function outgoingTextMatches(optimisticPlain: string, serverContent: string): boolean {
  const a = (optimisticPlain || '').trim();
  const b = (serverContent || '').trim();
  if (!a || !b) return false;
  if (a === b) return true;
  const stripped = b.replace(/^\*[^*]+\*\s*/, '').trim();
  return stripped === a;
}
